import React, { useEffect, useRef } from 'react';
import './GoldParticles.css';

const GoldParticles = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    const particleCount = 50;

    for (let i = 0; i < particleCount; i++) {
      const particle = document.createElement('div');
      particle.className = 'gold-particle';
      particle.style.left = Math.random() * 100 + '%';
      particle.style.animationDelay = Math.random() * 20 + 's';
      particle.style.animationDuration = 15 + Math.random() * 20 + 's';
      particle.style.opacity = Math.random() * 0.5 + 0.1;
      particle.style.width = particle.style.height = Math.random() * 4 + 2 + 'px';
      container.appendChild(particle);
    }

    return () => {
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }
    };
  }, []);

  return <div ref={containerRef} className="gold-particles-container" />;
};

export default GoldParticles;
